import React, { FunctionComponent } from 'react';

import styles from './VideoSlider.module.scss';
import SwiperCore, { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import CompareVideo from 'app/components/CompareVideo';
import { useModal } from 'app/context/Modal';

interface Props {
  videos: any;
  isReport?: boolean;
}

SwiperCore.use([Navigation, A11y]);

const VideoSlider: FunctionComponent<Props> = ({ videos, isReport }) => {
  const modal = useModal();
  const videoDetail = videos?.map((vid: any) => ({
    type: 'video',
    url: `https://www.youtube.com/embed/${
      vid?.url?.split('=')?.[1] ||
      vid?.url?.split('.be/')?.[1] ||
      vid?.url?.split('/shorts/')?.[1]
    }`,
  }));

  return (
    <div className={styles.VideoSlider}>
      <Swiper
        spaceBetween={20}
        slidesPerView={2}
        navigation
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          992: {
            slidesPerView: 2,
          },
        }}
      >
        {videos?.map((vid: any, index: number) => {
          return (
            <React.Fragment key={index}>
              <SwiperSlide key={index}>
                <CompareVideo
                  compareVideoDetails={vid}
                  currentIndex={index}
                  compId={`trends-compareVideo-swiperSlide-${index}`}
                  handleOpen={() => {
                    modal.show({
                      imageUrls: videoDetail,
                      imageIndex: index,
                    });
                  }}
                  isReport={isReport || false}
                />
              </SwiperSlide>
            </React.Fragment>
          );
        })}
      </Swiper>
    </div>
  );
};

export default VideoSlider;
